/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Decklists_ImmediateInputs */



/**
* | output |
* | --- |
* | "Changing this on a finished tournament takes effect immediately." |
*
* @param {Og_Cfg_Decklists_ImmediateInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_decklists_immediate = /** @type {((inputs?: Og_Cfg_Decklists_ImmediateInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Decklists_ImmediateInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier ce paramètre sur un tournoi terminé prend effet immédiatement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar esto en un torneo finalizado tiene efecto inmediato.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Alterar isso em um torneio concluído tem efeito imediato.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La modifica su un torneo concluso ha effetto immediato.")
	return /** @type {LocalizedString} */ ("Changing this on a finished tournament takes effect immediately.")
});